import React from 'react';
import SlotRenderer from '@plone/volto/components/theme/SlotRenderer/SlotRenderer';

export const NavigationFooter = ({ content }) => (
  <div className="nav-block nav-footer">
    <SlotRenderer name="navigationTools" content={content} />
  </div>
);
